import PermanentJobsReducer from './Reducer';

export default PermanentJobsReducer;

export type * from './States';
export type * from './Types';
